export default "__VITE_ASSET__DsZAQyes__"